import { ICompileService, IQService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";

import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";
import { percentageValueGetterFactory } from "../../../records/grids/cells/valueGetters";
import { machineConfigurationObjectName } from "../../shared/names";
import { RecordDataSource } from "../../../records/grids";

export { machineGameConfigurationObjectName as vsObjectName } from "../../shared/names";
import { machineGameConfigurationObjectName } from "../../shared/names";

machineGameConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineGameConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    machineGameConfigurationObjectName,
    [
      "$q",
      ServerUtilityName,
      GridSettingsServiceName,
      RecordGridViewServiceName,
      (
        $q: IQService,
        serverUtility: ServerUtility,
        gridSettingsService: GridSettingsService,
        recordGridViewService: RecordGridViewService
      ): GridConfiguration => {
        const machineConfigurationGridConfig =
          recordGridViewService.getGridConfiguration(
            machineConfigurationObjectName
          );
        return {
          columnDefinitionSet: machineGameConfigurationObjectName,
          defaultSort: RecordGridViewService.combineSort(
            machineConfigurationGridConfig?.defaultSort,
            "Order"
          ),
          gridDataSource: new RecordDataSource(
            serverUtility,
            "/api/machines/MachineGameConfiguration"
          ),
          gridSettings: gridSettingsService.getGridSettings(
            Symbol(machineGameConfigurationObjectName)
          ),
          namePlural: "Machine Game Configurations",
          nameSingular: "Machine Game Configuration",
          showAddButton: false,
        };
      },
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    machineGameConfigurationObjectName,
    [
      ColumnDefinitionServiceName,
      "$compile",
      ColumnDefinitionSetServiceName,
      function (
        columnDefinitionService: ColumnDefinitionService,
        $compile: ICompileService,
        columnDefinitionSetService: ColumnDefinitionSetService
      ) {
        const cols = [
          columnDefinitionService.getNumberColDef({
            field: "Id",
            hide: true,
          }),
          columnDefinitionService.getNumberColDef({
            field: "MachineConfigurationId",
            hide: true,
          }),
          columnDefinitionService.getStringColDef({
            field: "MachineDenominationName",
            header: "Denomination",
          }),
          columnDefinitionService.getStringColDef({
            field: "GameTheme",
          }),
          columnDefinitionService.getNumberColDef({
            field: "NumberOfPaylines",
            header: "Number Of Paylines",
          }),
          columnDefinitionService.getStringColDef({
            field: "PaylineType",
            header: "Payline Type",
            filter: new FilterProvider("PaylineType", $compile)
              .addFilter(
                "=",
                new OptionsFilter({
                  displayName: "=",
                  queryFieldNames: ["PaylineType"],
                  options: [
                    { display: "Paylines", value: "Paylines" },
                    { display: "Ways", value: "Ways" },
                  ],
                })
              )
              .getGridFilterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "MinBet",
            header: "Min Bet",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MaxBet",
            header: "Max Bet",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MinRtp",
            header: "Min RTP",
            valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
          }),
          columnDefinitionService.getNumberColDef({
            field: "MaxRtp",
            header: "Max RTP",
            valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
          }),
          columnDefinitionService.getNumberColDef({
            field: "TotalRtpWithProgressiveContribution",
            header: "Total Rtp With Progressive Contribution",
            valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
          }),
          columnDefinitionService.getBooleanColDef({
            field: "ProgressiveContributionIncluded",
            header: "Progressive Contribution Included",
          }),
          ...columnDefinitionSetService.getColumnDefinitionSet(
            machineConfigurationObjectName
          ),
        ];

        return cols;
      },
    ]
  );
}
